import { useEffect, useState } from "react";
import { fetchClinics, updateClinicAPI, createClinic, deleteClinicAPI } from "../services/apiServices";
import Footer from "../components/layout/Footer";
import Header from "../components/layout/Header";
import Spinner from "../components/Spinner";
import { useNavigate } from "react-router-dom";
import { ClinicModal } from "../components/modals/ClinicModal";
import { isAdmin } from "../services/config";
export const Clinic = () => {
    const [clinics, setClinics] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState({ add: false, edit: false });
    const [editingClinic, setEditingClinic] = useState(null);
    const navigate = useNavigate();
    const loadClinics = async () => {
        setLoading(true);
        try {
            const data = await fetchClinics();
            setClinics(Array.isArray(data) ? data : []);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        loadClinics();
    }, []);
    const refreshClinics = loadClinics;

    const handleAddClinic = async (clinicData) => {
        await createClinic(clinicData);
        refreshClinics();
    };
    const handleUpdateClinic = async (clinicData) => {
        if (!editingClinic) return;
        await updateClinicAPI({ clinic_id: editingClinic.clinic_id, ...clinicData });
        refreshClinics();
    };
    return (
        <div>
            {loading ? (
                <div className="spinner-center" style={{ minHeight: "800px" }}>
                    <Spinner label="Loading studies" />
                </div>
            ) : (
                <>
                    <div className="container">
                        <Header
                            actions={
                                <button
                                    className="button secondary"
                                    onClick={() => navigate("/home")}
                                >
                                    All Studies
                                </button>
                            }
                        />
                        {isAdmin() && <button className="clinic-button" onClick={(e) => {
                            e.stopPropagation();
                            setShowModal({ ...showModal, add: true });
                        }}>
                            Add Clinic
                        </button>}
                        <div className="table-container">
                            <table className="responsive-table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Clinic Name</th>
                                        <th>Clinic Email</th>
                                        <th>Clinic Address</th>
                                        <th>Is Study</th>
                                        {isAdmin() && <th>Actions</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {clinics.length === 0 ? (
                                        <tr>
                                            <td colSpan="3" className="empty-state">
                                                No clinic found.
                                            </td>
                                        </tr>
                                    ) : (
                                        clinics.map((clinic) => (
                                            <tr key={clinic.clinic_id}
                                            //  onClick={() => navigate(`/clinic/${clinic._id}`)}
                                            >
                                                <td data-label="ID">{clinic.id}</td>
                                                <td data-label="Clinic Name">{clinic.clinic_name}</td>
                                                <td data-label="Clinic Email">{clinic.clinic_email || "-"}</td>
                                                <td data-label="Clinic Address">{clinic.clinic_address || "-"}</td>
                                                <td data-label="Is Study">
                                                    {clinic.is_study?.data
                                                        ? clinic.is_study.data[0] === 1
                                                            ? "Yes"
                                                            : "No"
                                                        : "-"}
                                                </td>
                                                {isAdmin() && (<td data-label="Actions">
                                                    <button
                                                        className="button secondary small"
                                                        style={{ padding: "4px 12px" }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setEditingClinic(clinic);
                                                            setShowModal({ ...showModal, edit: true });
                                                        }}
                                                    >
                                                        Update
                                                    </button>
                                                    <button
                                                        className="button danger small"
                                                        style={{ padding: "4px 12px" ,marginLeft:"10px"}}
                                                        onClick={async (e) => {
                                                            e.stopPropagation();
                                                            if (window.confirm("Are you sure you want to delete this clinic?")) {
                                                                try {
                                                                    await deleteClinicAPI(clinic.clinic_id);
                                                                    refreshClinics();
                                                                } catch (err) {
                                                                    console.error(err);
                                                                    alert("Failed to delete clinic");
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        Delete
                                                    </button>
                                                </td>)}
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>

                        </div>
                    </div>
                </>
            )}

            <Footer />
            <ClinicModal
                open={showModal.add || showModal.edit}
                onClose={() => {
                    setShowModal({ add: false, edit: false });
                    setEditingClinic(null);
                }}
                onSubmit={showModal.edit ? handleUpdateClinic : handleAddClinic}
                initial={showModal.edit ? editingClinic : null}
                title={showModal.edit ? "Update Clinic" : "Add Clinic"}
                submitLabel={showModal.edit ? "Update" : "Create"}
            />
        </div>
    );
}
